import { Component, OnInit } from '@angular/core';
import { CalendarOptions } from '@fullcalendar/angular';
import { RoutePath } from 'app/routing/routes';
import { TINYMCE_LIST_CONFIG } from 'app/shared/editor-config';
import { BulletinService } from 'app/_services/bulletin.service';
import { CalendarEventDetailsService } from 'app/_services/calendarEventDetails.service';
import { CalendarEventsService } from 'app/_services/calendarEvents.service';
import { HallOfFamesService } from 'app/_services/hallOfFames.service';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
    bulletin: any;
    bulletinLive: boolean = false;
    events: any[] = [];
    details: any[] = [];
    hallOfFames: any[] = [];
    loadingBulletins = true;
    loadingEvents = true;
    loadingDetails = true;
    loadingHOF = true;
    config = TINYMCE_LIST_CONFIG;
    RoutePath = RoutePath;
    calendarOptions: CalendarOptions = {
        initialView: 'dayGridMonth',
    };

    constructor(
        private bulletinService: BulletinService,
        private calEventsService: CalendarEventsService,
        private calEventsDetailsService: CalendarEventDetailsService,
        private hallOfFameService: HallOfFamesService
    ) {}

    ngOnInit(): void {
        this.bulletinService.getLatestBulletin('').subscribe((bulletin) => {
            this.bulletin = bulletin;
            this.bulletinLive = this.bulletinService.isBulletinLive(bulletin);

            setTimeout((_) => (this.loadingBulletins = false), 500);
        });

        this.calEventsService.getCalendarEvents().subscribe((allEvents) => {
            this.events = allEvents
                .sort((b, a) => (a.eventId > b.eventId ? 1 : -1))
                .slice(0, 4)
                .map((e) => {
                    return { eventId: e.eventId, eventName: e.eventName };
                });

            setTimeout((_) => {
                this.loadingEvents = false;
                this.calEventsDetailsService.getAllCalendarEventDetails().subscribe((details) => {
                    this.details = details
                        .sort((b, a) => (a.instId > b.instId ? 1 : -1))
                        .slice(0, 4)
                        .map((d) => {
                            const event = allEvents.find((e) => e.eventId === d.instEventId);
                            const name = event.eventName ? event.eventName : '[MISSING EVENT NAME]';

                            return { eventName: name, startDate: d.startDate, endDate: d.endDate };
                        });

                    setTimeout((_) => (this.loadingDetails = false), 500);
                });
            }, 500);
        });

        this.hallOfFameService.getMostRecent().subscribe((hallOfFames) => {
            this.hallOfFames = hallOfFames
                .sort((b, a) => (a.hallOfFameId > b.hallOfFameId ? 1 : -1))
                .map((hof) => hof?.prefix + ' ' + hof?.firstName + ' ' + hof?.lastName + ' ' + hof?.suffix);

            setTimeout((_) => (this.loadingHOF = false), 500);
        });
    }

    testMessageLog() {
        this.calEventsService.testMessageLog().subscribe((_) => {
            console.log('Test Complete');
        });
    }
}
